// @ts-nocheck

import { getGridData } from 'models/dynamicGrid/selector';
import { SELECT_SKUS_TABLE_ID } from './constants';

export const getDistributeAvailabilityNumber = (state) => {
	return getGridData(state, SELECT_SKUS_TABLE_ID)?.[0]?.DistNumber;
};
